export enum StoryListType {
    MyStories = 'myStories',
    SharedStories = 'sharedStories',
    StoryTemplates = 'storyTemplates',
    PublicStories = 'publicStories',
}
